<template>
  <div>
    <DashboardHeader title="Student Reports">
      <PDFViewer :pdf="reportsPDF" v-if="reportsPDF"></PDFViewer>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import PDFViewer from "@/components/myLibrary/PDFViewer.vue";

export default {
  components: { DashboardHeader, PDFViewer },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },

  mounted() {
    this.students = this.$route.params.selectedStudents;
    this.term = this.$route.params.selectedReportTerm;
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/student-reports-fpdf",
        {
          students: this.$route.params.selectedStudents,
          term: this.$route.params.selectedReportTerm,
          year: this.$route.params.selectedYear,
          reportSource: this.$route.params.reportSource,
          selectedClass: this.$route.params.selectedClass,
          selectedSids: this.$route.params.selectedSids
        },
        this.getAccessToken
      )
      .then(reportsPDF => {
        this.reportsPDF = "reportsPDF/" + reportsPDF;
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    students: [],
    term: null,
    reportsPDF: null
  })
};
</script>

